import { Injectable } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { EventsService } from 'src/packages/mitsBasics';

export type EASTER_EGG = 'christmas';

/** Event-Key: Netzwerkstatus hat gewechselt; Payload = `connected` (boolean). */
export const NETWORK_STATUS_CHANGED_EVENT = 'system:networkStatusChanged';

@Injectable({
  providedIn: 'root',
})
export class SystemHelper {
  networkListener?: PluginListenerHandle;

  isOnline: boolean = false;
  isDeveloper: boolean = false;
  isDownloadRunning: boolean = false;
  isBackendOnline: boolean = true;
  isVersionOutdated: boolean = false;
  versionDetails?: { current: string; latest: string };
  isInLogoutProcess = false;
  currentEvent?: EASTER_EGG;

  constructor(private readonly events: EventsService) {
    this.updateCurrentEvent();
  }

  async initializeNetworkCheck() {
    const status = await Network.getStatus();
    this.isOnline = status.connected;
    this.networkListener = Network.addListener(
      'networkStatusChange',
      (status) => {
        this.isOnline = status.connected;
        // Konsumenten (z.B. App-Start-Recovery) reagieren auf das Online-Werden.
        this.events.publish(NETWORK_STATUS_CHANGED_EVENT, status.connected);
      }
    );
  }

  /**
   * Copies the given text to the clipboard
   * @param text to copy
   */
  copyToClipboard(text: string) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  }

  private updateCurrentEvent() {
    const now = new Date();
    if (now.getMonth() === 11) this.currentEvent = 'christmas';
  }
}
